import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import Cookies from 'universal-cookie';

import moment from 'moment';
import 'moment/locale/pt-br';

//components
import Paginacao from '../../../../../../../../../util/paginacao/.mixins/paginacao';
import CardPedido from '../../../../../../../../../util/cardPedido/.mixins/index';
import SearchPedido from '../../../../../../../../../util/searchPedido/.mixins/index';
import OpcoesBuscaPopoverAllFilter from '../../../../../../../../../util/opcoesBuscaPopoverAllFilters/.mixins';
import ModalTable from '../../../../../../../../../util/modalDinamica/childrens/modalTable/.mixins/modalTable';

//controllers
import { getPedidosRespondidos, getPedidosAgendados } from '../../../../../../../../../../controllers/agendamentosRespondidos';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default function AgendamentosRecusados(props) {
  //CardPedido
  const { fornecedor, firstLoad, opcoesFilial } = props.state;
  const [pedidos, setPedidos] = useState([]);
  const bt_component = [
    {
      label: 'VER ITENS RECUSADOS',
      handler: (props) => {
        setIsOpenModalTable(!isOpenModalTable);
        setIsLoading(!isLoading);
        loadDataModal(props);
      },
    },
  ];

  //Paginação
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const [totalRows, setTotalRows] = useState(0);

  //SearchPedido
  const [searchFieldExternal, setSearchFieldExternal] = useState('');
  const [dtInitial, setDtInitial] = useState(moment().toDate());
  const [dtEnd, setDtEnd] = useState(moment().add(30, 'days').toDate());
  const { childAlerta, setState } = props;

  //ModalTable
  const [isOpenModalTable, setIsOpenModalTable] = useState(false);
  const [isAtivaFilter, setIsAtivaFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [itensPedido, setItensPedido] = useState([]);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const colunasModalTable = [
    {
      name: 'suggestedScheduleDate',
      label: 'Data Sugerida',
    },
    {
      name: 'rejectionReasonDescription',
      label: 'Motivo',
    },
    {
      name: 'productId',
      label: 'ID Prod',
    },
    {
      name: 'numericCode',
      label: 'Cód num',
    },
    {
      name: 'alphaId',
      label: 'Alfa',
    },
    {
      name: 'productName',
      label: 'Nome do Produto',
    },
    {
      name: 'colorAbbreviation',
      label: 'Cor',
    },
    {
      name: 'sciaStatusDescription',
      label: 'Status',
    },
  ];
  const [descriptionsModalTable, setDescriptionsModalTable] = useState({
    nr_pedido: 0,
    dt_agendamento: '',
    ds_filial: '',
    dt_sugerida: null,
    motivo_recusa: null,
  });

  //OpcoesBusca
  const [searchField, setSearchField] = useState('');
  const [colunasOpcoesDeBusca, setColunasOpcoesDeBusca] = useState([
    {
      key: 'Número do Pedido',
      value: false,
    },
    {
      key: 'ID Produto',
      value: false,
    },
    {
      key: 'Código Numérico',
      value: false,
    },
    {
      key: 'Nome do Produto',
      value: false,
    },
  ]);

  //OpcoesBuscaTags
  const [colunasFilterTags, setColunasFilterTags] = useState([
    {
      key: 'Número do Pedido',
      value: '',
      origemValue: ""
    },
    {
      key: 'ID Produto',
      value: '',
      origemValue: ""
    },
    {
      key: 'Código Numérico',
      value: '',
      origemValue: ""
    },
    {
      key: 'Nome do Produto',
      value: '',
      origemValue: ""
    },
    {
      key: "Data de agendamento",
      value: "",
      origemValue: ""
    },
    {
      key: 'Filial',
      value: '',
      origemValue: ""
    },
  ]);

  const [escolhaFilial, setEscolhaFilial] = useState({ id: 0, name: "Selecione uma filial" });

  const dateFormat = (date) => {
    return moment(date).format('DD/MM/YYYY');
  };

  const handlerChangeDateInitial = async (value) => {
    setDtInitial(value);
    let newColunasFilterTags = colunasFilterTags;
    newColunasFilterTags[4].value = `${dateFormat(value)} - ${dateFormat(dtEnd)}`;
    setColunasFilterTags(newColunasFilterTags);
  };

  const handlerChangeDateEnd = async (value) => {
    setDtEnd(value);
    let newColunasFilterTags = colunasFilterTags;
    newColunasFilterTags[4].value = `${dateFormat(dtInitial)} - ${dateFormat(value)}`;
    setColunasFilterTags(newColunasFilterTags);
  };

  //SearchPedido - Functions()
  const handleChangeSearchFieldPedido = (event) => {
    setSearchFieldExternal(event.target.value);
  };

  const handleClickSearchField = async () => {
    await setState({ firstLoad: true })

    getPedidos({
      linha_inicial: 0,
      qtd_registro: rowsPerPage,
      tipo_load: 'searchField'
    });
    await setState({ firstLoad: false })
  };

  //Paginação - Functions()
  const onChangePage = (pageFrom) => {
    getPedidos({
      linha_inicial: pageFrom,
      qtd_registro: rowsPerPage,
      tipo_load: 'onchange'
    });
  };

  const handlerChangeSearchFilterTag = async (i, coluns) => {
    let newColunasFilterTags = colunasFilterTags;

    const nameObject = coluns[i].key;
    const indexObject = colunasFilterTags.map(e => e.key).indexOf(nameObject);

    if (indexObject < 0) return;

    if (coluns[i].value) {
      newColunasFilterTags[indexObject].value = searchField;
    } else {
      newColunasFilterTags[indexObject].value = "";
    }
    // sem essa conversão não renderiza o array tags
    await setColunasFilterTags(JSON.parse(JSON.stringify(newColunasFilterTags)));
  };

  //OpcoesBusca - Functions()
  const handlerClickCheckbox = async (i) => {
    const coluns = colunasOpcoesDeBusca.map((coluna, index) => {
      return index === i ? { ...coluna, value: !coluna.value } : coluna;
    });
    await setColunasOpcoesDeBusca(coluns);
    await handlerChangeSearchFilterTag(i, coluns);
  };

  const handleChangeSearchFieldOpcoesBusca = (event) => {
    event.persist();
    setSearchField(event.target.value);
  };

  //OpcoesBuscaPopover - Functions()
  const handlerCleanFilters = async () => {
    await setState({ firstLoad: true })
    setSearchField('');
    setSearchFieldExternal('');
    setDtInitial(moment().toDate());
    setDtEnd(moment().add(30, 'days').toDate());
    setEscolhaFilial({ id: 0, name: "Selecione uma filial" });

    setColunasOpcoesDeBusca(
      colunasOpcoesDeBusca.map((coluna) => {
        coluna.value = false;
        return coluna;
      })
    );

    setColunasFilterTags(
      colunasFilterTags.map((coluna) => {
        coluna.value = '';
        return coluna;
      })
    );
    getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'cleanFilters' });
    await setState({ firstLoad: false })
  };
  const handlerAplicarFilters = async () => {
    await setState({
      firstLoad: true,
      isLoading: true
    });
    const index = colunasOpcoesDeBusca.findIndex(
      (coluna, index) => coluna.value === true && colunasFilterTags[index].value === ''
    );
    setColunasFilterTags(
      colunasFilterTags.map((coluna, i) => {
        return i === index ? { ...coluna, value: searchField } : coluna;
      })
    );
    setSearchField('');
    await getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'applyFilters' });
    await setState({
      firstLoad: false,
      isLoading: false
    });
  };

  //OpcoesBuscaTags - Functions()
  const handlerClearFilterTag = async (i) => {
    await setColunasFilterTags(
      colunasFilterTags.map((coluna, index) => {
        return index === i ? { ...coluna, value: '' } : coluna;
      })
    );

    await setColunasOpcoesDeBusca(
      colunasOpcoesDeBusca.map((coluna, index) => {
        return index === i ? { ...coluna, value: false } : coluna;
      })
    );

    await setIsAtivaFilter(true);
  };

  //ModalTable - Functions()
  const handleDialogModalTable = () => {
    setIsOpenModalTable(!isOpenModalTable);
  };

  const loadDataModal = (props) => {
    setIsLoading(true);
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    const { nr_pedido, dt_agendamento, ds_filial, cd_filial, element } = props;

    const filters = {
      initialRow: 0,
      nextRows: 1000,
      purchaseOrderId: element.purchaseOrderId,
      branchId: element.branchDeliveryId,
      initialScheduleDate: element.expectedDeliveryDate,
      finalScheduleDate: element.expectedDeliveryDate,
      personId: fornecedor,
      statusSciaIs: 'R',
    };

    setDescriptionsModalTable({
      ...descriptionsModalTable,
      nr_pedido: nr_pedido,
      dt_agendamento,
      ds_filial,
      cd_filial,
      //dt_sugerida: element.suggestedScheduleDate,
      //motivo_recusa: element.rejectionReasonDescription
    });

    getPedidosRespondidos(token, filters)
      .then(async (response) => {
        setIsLoading(false);
        const responseItens = JSON.parse(response.body);
        let contIdItem = 0

        const arrayItens = responseItens.map((item) => {
          contIdItem++
          item.STATUS = 'Recusado'
          item.id_item = contIdItem
          item.CHECK = false
          return {
            ...item
          };
        });
        setItensPedido(arrayItens);
      })
      .catch((error) => {
        setIsError(true);
        setError(error);
        console.error(error);
        props.childAlerta.current.retorno(error.message, 'error');
      });
  };

  const parseDate = (date) => {
    const [newDate] = date.split(' ');
    const finalDate = newDate.split('/').reverse().join('-');
    return finalDate;
  };

  const isInt = (value) => {
    return !isNaN(value) &&
      parseInt(Number(value)) == value &&
      !isNaN(parseInt(value, 10));
  };

  const getPedidos = async ({ linha_inicial, qtd_registro, tipo_load }) => {
    await setState({ isLoading: true })
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    let nr_pc = null;
    let id_prod = null;
    let cd_num = null;
    let nm_prod = null;
    let cd_fil = "";

    const arrayColNrPcTag = colunasFilterTags
      .filter(element => (
        element.key === "Número do Pedido" &&
        element.value !== element.origemValue
      ));

    const arrayColNrProdTag = colunasFilterTags
      .filter(element => (
        element.key === "ID Produto" &&
        element.value !== element.origemValue
      ));

    const arrayColCdNumTag = colunasFilterTags
      .filter(element => (
        element.key === "Código Numérico" &&
        element.value !== element.origemValue
      ));

    const arrayColDsProdTag = colunasFilterTags
      .filter(element => (
        element.key === "Nome do Produto" &&
        element.value !== element.origemValue
      ));

    const arrayColFilialTag = colunasFilterTags
      .filter(element => (
        element.key === "Filial" &&
        element.value !== element.origemValue
      ));

    const arrayDatasTags = colunasFilterTags
      .filter(element => (
        element.key === "Data de agendamento" &&
        element.value !== element.origemValue
      ));

    if (arrayColNrPcTag.length > 0) {
      nr_pc = parseInt(arrayColNrPcTag[0].value);

      if (!isInt(nr_pc)) {
        props.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
        return;
      }
    }

    if (arrayColNrProdTag.length > 0) {
      id_prod = parseInt(arrayColNrProdTag[0].value);

      if (!isInt(id_prod)) {
        props.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
        return;
      }
    }

    if (arrayColCdNumTag.length > 0) {
      cd_num = parseInt(arrayColCdNumTag[0].value);

      if (!isInt(cd_num)) {
        props.childAlerta.current.retorno('Campo precisa ser um número!', 'warning');
        return;
      }
    }

    if (arrayColDsProdTag.length > 0 && !isInt(searchField)) {
      nm_prod = arrayColDsProdTag[0].value;
    }

    if (arrayColFilialTag.length > 0) {
      cd_fil = arrayColFilialTag[0].value;
    }

    if (tipo_load == "searchField") {
      if (isInt(searchFieldExternal)) {
        nr_pc = searchFieldExternal;
      } else {
        nm_prod = searchFieldExternal;
      }
    } else if (tipo_load == "applyFilters") {
      if (
        arrayColNrPcTag.length == 0 &&
        arrayColNrProdTag.length == 0 &&
        arrayColCdNumTag.length == 0 &&
        arrayColDsProdTag.length == 0 &&
        searchField != ""
      ) {
        setSearchField("");
      }
    }

    let dtInitialp, dtEndp = null;
    if (arrayDatasTags.length > 0) {
      dtInitialp = moment(dtInitial).format("DD/MM/YYYY");
      dtEndp = moment(dtEnd).format("DD/MM/YYYY");
    }

    let filters = {
      initialRow: linha_inicial,
      nextRows: qtd_registro,
      personId: fornecedor,
      statusSciaIs: 'R',
    };

    if (nr_pc != null) {
      filters = { ...filters, purchaseOrderId: nr_pc };
    }
    if (id_prod != null) {
      filters = { ...filters, productId: id_prod };
    }
    if (cd_num != null) {
      filters = { ...filters, numericCode: cd_num };
    }
    if (nm_prod != null) {
      filters = { ...filters, productName: nm_prod };
    }
    if (dtInitialp != null) {
      filters = { ...filters, initialScheduleDate: dtInitialp };
    }
    if (dtEndp != null) {
      filters = { ...filters, finalScheduleDate: dtEndp };
    }
    if (cd_fil !== "") {
      filters = {
        ...filters,
        branchId: (cd_fil === "") ? null : escolhaFilial.id
      };
    }

    getPedidosAgendados(token, filters)
      .then(async (response) => {
        const responseRecusados = JSON.parse(response.body);
        setTotalRows(responseRecusados.length > 0 ? responseRecusados[0].totalRows : 0);
        responseRecusados.map((pedido) => {
          return {
            ...pedido,
          };
        });
        setPedidos(responseRecusados);
        await setState({ isLoading: false })
      })
      .catch((error) => {
        setIsError(true);
        setError(error);
        console.error(error);
        props.childAlerta.current.retorno(error.message, 'error');
      });
  };

  const handlerEscolhaFilialSetTag = async (value) => {
    let newColunasFilterTags = colunasFilterTags;

    const indexObject = colunasFilterTags
      .map(e => e.key)
      .indexOf("Filial");
    if (indexObject < 0) return;

    if (value.id > 0)
      newColunasFilterTags[indexObject].value = value.id;
    else
      newColunasFilterTags[indexObject].value = "";

    await setColunasFilterTags(JSON.parse(JSON.stringify(newColunasFilterTags)));
  };

  const handlerChangeEscolhaFilial = async (value) => {
    await setEscolhaFilial(value);
    await handlerEscolhaFilialSetTag(value);
  };

  const loadInit = async () => {
    await handlerCleanFilters();
    await getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'firstLoad' });
  };

  useEffect(() => {
    loadInit();
  }, [fornecedor]);

  useEffect(() => {
    getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'rowsPerPage' });
  }, [rowsPerPage]);

  useEffect(() => {
    getPedidos({ linha_inicial: 0, qtd_registro: rowsPerPage, tipo_load: 'isAtivaFilter' });
    setIsAtivaFilter(false);
  }, [isAtivaFilter, setIsAtivaFilter]);

  const classes = useStyles();
  return (
    <>
      <div className={classes.contentTop}>
        <SearchPedido
          searchField={searchFieldExternal}
          searchStatus={colunasOpcoesDeBusca[0].value}
          handleChangeSearchFieldPedido={handleChangeSearchFieldPedido}
          handleClickSearchField={handleClickSearchField}
        />

        <Typography style={{ marginLeft: '30px' }}>
          <b>
            A Tok&Stok entrará em contato para o reagendamento da entrega dos pedidos
            abaixo.{' '}
          </b>
          Caso deseje entrar em contato, você pode encaminhar um e-mail para o analista de
          compras Tok&Stok responsável.
        </Typography>
      </div>

      <div className={classes.contentMiddle}>
        <OpcoesBuscaPopoverAllFilter
          searchField={searchField}
          dtInitial={dtInitial}
          dtEnd={dtEnd}
          escolhaData={"Data agendamento"}
          isColunasMultiple={true}
          isFixed={true}
          opcoesFilial={opcoesFilial}
          escolhaFilial={escolhaFilial}
          buttonVariant={'text'}

          colunas={colunasOpcoesDeBusca}
          colunasFilterTags={colunasFilterTags}

          handlerClickCheckbox={handlerClickCheckbox}
          handleChangeSearchFieldPedido={handleChangeSearchFieldOpcoesBusca}

          handlerCleanFilters={handlerCleanFilters}
          handlerAplicarFilters={handlerAplicarFilters}

          handlerClearFilterTag={handlerClearFilterTag}

          handlerChangeDateInitial={handlerChangeDateInitial}
          handlerChangeDateEnd={handlerChangeDateEnd}
          handlerChangeEscolhaFilial={handlerChangeEscolhaFilial}
        />

        <Typography>
          Total de {totalRows}
          {totalRows === 1 ? ' agendamento recusado' : ' agendamentos recusados'}
        </Typography>
      </div>

      {pedidos.map((pedido, index) => (
        <div className={classes.cardPedido} key={index}>
          <CardPedido
            className={classes.cardPedido}
            nr_pedido={pedido.purchaseOrderId}
            cd_filial={pedido.branchId}
            dt_agendamento={pedido.scheduleDate}
            dt_sugerida={pedido.expectedDeliveryDate}
            ds_filial={`${pedido.branchDeliveryId} - ${pedido.branchName}`}
            ds_msg=''
            bt_component={bt_component}
            element={pedido}
          />
        </div>
      ))}

      <ModalTable
        state={{
          isLoading,
          isOpenModalTable,
          descriptionsModalTable,
          columns: colunasModalTable,
          itensTable: itensPedido,
          isError,
          error,
        }}
        handleDialogModalTable={handleDialogModalTable}
      />

      <Paginacao
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        rowsPerPageOptions={rowsPerPageOptions}
        onChangePage={onChangePage}
        firstLoad={firstLoad}
        setRowsPerPage={setRowsPerPage}
      />
    </>
  );
}
